import { Button, Checkbox, Col, Divider, Form, Input, Row, Space } from "antd";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { TipoDocumentoModel } from "../../../../models/tipoDocumento/tipoDocumentoModel";
import { atualizarTipoDocumento, buscarTipoDocumento, cadastrarTipoDocumento } from "../../../../services/tipoDocumentoService";
import TextArea from "antd/lib/input/TextArea";
import { setModalCadastrarTipoDocumento, TipoDocumentoState } from "../../../../redux/slices/tipoDocumento/tipoDocumentoSlice";

const CadastroEdicaoTipoDocumento = () => {
  //estados globais
  const tipoDocumentoState = useAppSelector((state) => state.tipoDocumento);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(tipoDocumentoState.entity).length !== 0;

  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      tipoDocumentoState.entity.receita && tipoDocumentoState.entity.despesa
        ? form.setFieldValue("tipo", ["R", "D"])
        : tipoDocumentoState.entity.receita
        ? form.setFieldValue("tipo", ["R"])
        : form.setFieldValue("tipo", ["D"]);
      form.setFieldsValue({
        ...tipoDocumentoState.entity,
      });
    }
  }, [tipoDocumentoState.entity]);

  const submit = (value: any) => {
    const objRecDesp = value.tipo.length === 1 ? (value.tipo[0] === "R" ? { despesa: false, receita: true } : { receita: false, despesa: true }) : { receita: true, despesa: true };

    delete value.tipo;

    const submitTipoDocumento: TipoDocumentoModel = { ...value, ...objRecDesp };
    
    if (editar) {
      submitTipoDocumento.id = tipoDocumentoState.entity.id;
      dispatch(atualizarTipoDocumento({ value: submitTipoDocumento, busca: tipoDocumentoState.busca }));
    } else {
      dispatch(cadastrarTipoDocumento({ value: submitTipoDocumento, busca: tipoDocumentoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarTipoDocumento(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={18}>
          <Form.Item
            label="Nome do Tipo Documento"
            name="denominacao"
            className="denominacaoFeriado"
            rules={[
              {
                required: true,
                message: "Digite o banco",
              },
            ]}
          >
            <Input type="text" ref={inputInicial} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Tipo"
            name="tipo"
            rules={[
              {
                required: true,
                message: "Deve ser selecionado ao menos um",
              },
            ]}
          >
            <Checkbox.Group>
              <Checkbox value="R">Receita</Checkbox>
              <Checkbox value="D">Despesa</Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item
            label="Descrição"
            name="descricao"
            rules={[
              {
                required: true,
                message: "Digite a descrição do tipo documento",
              },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroEdicaoTipoDocumento;
